import { useContext } from 'react';

import { LoginContext } from '../../contexts/LoginContext/LoginContext';

export function useLoginOrigin() {
  const context = useContext(LoginContext);

  if (!context) {
    throw new Error(
      'useLoginOrigin must be used withinh a LoginContextProvider',
    );
  }

  return context;
}
